import {CHANGE_TEMPORARY_DATE} from './actions';
import {CLOSE_SETTINGS} from '../UI/actions';

export function settingsView(state: SettingsViewState, {type, payload}: Action): SettingsViewState {
  switch (type) {
    case CLOSE_SETTINGS:
      return {
        ...state,
        tempBudgetFinishDate: 0,
      };

    case CHANGE_TEMPORARY_DATE:
      return {
        ...state,
        tempBudgetFinishDate: payload,
      };

    default:
      return state;
  }
}
